module.exports = __webpack_public_path__ + "img/zoetrope7.a0c249e6.png";